import React, { useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { debounce } from 'lodash'
import { setFilterLetters } from '../store/filtersSlice'
import { useGetRosterQuery } from '../store/rosterApi'
import SearchInput from './SearchInput'

const t = (key, opts) => (!window.I18n ? key : window.I18n.t(key, opts))

const RosterFilterBar = () => {
  const dispatch = useDispatch()
  const filters  = useSelector((state) => state.filters)
  const { data } = useGetRosterQuery(filters)
  const [localInput, setLocalInput] = useState('')

  const debouncedDispatch = useCallback(
    debounce((value) => {
      // below 3 chars we clear rather than skip, or the box and the table disagree
      dispatch(setFilterLetters(value.length >= 3 ? value : ''))
    }, 300),
    [dispatch]
  )

  const handleTextChange = (e) => {
    setLocalInput(e.target.value)
    debouncedDispatch(e.target.value)
  }

  const handleClear = () => {
    setLocalInput('')
    dispatch(setFilterLetters(''))
  }

  return (
    <div className='col-xs-12 col-sm-5 col-md-4 customer-group-members-filter-bar__wrapper'>
      <SearchInput
        value={localInput}
        onChange={handleTextChange}
        onClear={handleClear}
        placeholder={t('customer_groups.groups.members.search_placeholder')}
      />
      {data?.total_entries !== undefined && (
        <span className='customer-group-members-golfer-count'>
          {t('customer_groups.groups.members.golfers_count', { count: data.total_entries })}
        </span>
      )}
    </div>
  )
}

export default RosterFilterBar
